import React, { memo } from 'react';
import classnames from 'classnames';
import { template } from '@iyunbao/cr-engine';

import { BaseWidgetProps } from '../utils/type';

interface BaseOption {
  colspan?: number;
  rowSpan?: number;
  label?: string;
  style?: any;
  value?: any;
}

interface OptionsType {
  [index: number]: Array<BaseOption>
}

export interface TableProps extends BaseWidgetProps {
  optionsVal: OptionsType;
}

function UNormalTable(props: TableProps) {
  const {
    prefixCls = 'crm-normal-table',
    className,
    optionsVal,
  } = props;

  const cls = classnames(prefixCls, className);

  return (
    <div
      className={cls}
    >
      <table>
        <tbody>
          {Array.isArray(optionsVal) && optionsVal.map((item, key) => (
            <tr key={key}>
              {item.map((subI, subK) => {
                const { colspan = 1, rowSpan = 1, label = '', style, value } = subI;

                return (
                  <td
                    key={subK}
                    colSpan={colspan}
                    rowSpan={rowSpan}
                    style={style}
                  >
                    {template(label, value)}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default memo(UNormalTable);
